import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiAssertive: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_17006)">
                <path
                    d="M6.5 0.5C2.91015 0.5 0 3.41015 0 7C0 10.5899 2.91015 13.5 6.5 13.5C10.0899 13.5 13 10.5899 13 7C13 3.41015 10.0899 0.5 6.5 0.5ZM6.5 12.6875C3.35888 12.6875 0.8125 10.1411 0.8125 7C0.8125 3.85888 3.35888 1.3125 6.5 1.3125C9.64112 1.3125 12.1875 3.85888 12.1875 7C12.1875 10.1411 9.64112 12.6875 6.5 12.6875Z"
                    fill="#770CF9"
                />
                <path
                    d="M10.5625 4.15625H2.4375C2.21312 4.15625 2.03125 4.33812 2.03125 4.5625V5.78125C2.03125 6.45436 2.57689 7 3.25 7H4.875C5.54811 7 6.09375 6.45436 6.09375 5.78125V4.96875H6.90625V5.78125C6.90625 6.45436 7.45189 7 8.125 7H9.75C10.4231 7 10.9688 6.45436 10.9688 5.78125V4.5625C10.9688 4.33812 10.7869 4.15625 10.5625 4.15625Z"
                    fill="#770CF9"
                />
                <path
                    d="M5.6875 9.84375V10.6562C7.25806 10.6562 8.53125 9.38306 8.53125 7.8125H7.71875C7.71875 8.93433 6.80933 9.84375 5.6875 9.84375Z"
                    fill="#770CF9"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_17006">
                    <rect width="13" height="13" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiAssertive;
